enum UiEventType {
    BUTTON_CLICK_VIEW_SPEC = 'BUTTON_CLICK_VIEW_SPEC'
}

export default UiEventType;
